
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniahireforcorporateeventspune() {



    const cardData =
    {
        keyword: 'Urbania Hire for Corporate Events Pune   ',
        heading: 'Amruta Travels: Urbania Hire for Corporate Events Pune  ',
        headingDescription: 'Amruta Travels offers Urbania Hire for Corporate Events in Pune, providing a premium and reliable transportation solution for office outings, client meetings, conferences, team-building trips, and corporate tours. Our luxurious Force Urbania vans, available in 13-seater and 17-seater options, feature spacious interiors, air-conditioning, and modern amenities to ensure a comfortable and professional journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes corporate Urbania hire in Pune seamless, safe, and stress-free, helping your team travel together in comfort and style.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



 "services": [
  {
    "name": "Urbania on rent in Shivaji Nagar Pune",
    "description": "Urbania on rent in Shivaji Nagar Pune offering premium group transportation with spacious push-back seats, powerful air conditioning, smooth suspension, and professional drivers. Ideal for corporate travel, local sightseeing, airport transfers, meetings, and outstation journeys from central Pune locations."
  },
  {
    "name": "Force Urbania hire in Camp Pune",
    "description": "Force Urbania hire in Camp Pune suitable for families, corporate teams, tourists, and event travel. Provides luxury interiors, ample luggage space, clean vehicles, and experienced chauffeurs for city and long-distance travel."
  },
  {
    "name": "Urbania rental near Swargate Pune",
    "description": "Urbania rental near Swargate Pune ideal for tour departures, pilgrimage travel, long-route journeys, and group transportation with easy highway access and reliable service."
  },
  {
    "name": "Urbania van hire near Pune Railway Station",
    "description": "Urbania van hire near Pune Railway Station for convenient pickup and drop of families, corporate groups, tourists, and wedding guests with punctual service and spacious luggage capacity."
  },
  {
    "name": "Urbania on rent in Deccan Pune",
    "description": "Urbania on rent in Deccan Pune for executive travel, family trips, corporate meetings, and comfortable outstation journeys with premium interiors and professional service."
  },
  {
    "name": "Urbania on rent in Baner Pune",
    "description": "Urbania on rent in Baner Pune catering to IT professionals, corporate offices, families, and groups requiring luxury travel for city, airport, and outstation needs."
  },
  {
    "name": "Force Urbania hire in Wakad Pune",
    "description": "Force Urbania hire in Wakad Pune ideal for IT employees, corporate travel, airport transfers, weekend trips, and long-distance group transportation with comfort and safety."
  },
  {
    "name": "Urbania rental in Hinjewadi Pune",
    "description": "Urbania rental in Hinjewadi Pune designed for IT parks, corporate offices, conferences, employee movement, and premium group travel with reliable and punctual service."
  },
  {
    "name": "Urbania on rent in Aundh Pune",
    "description": "Urbania on rent in Aundh Pune offering executive-level comfort for corporate travel, family journeys, weddings, events, and outstation tours."
  },
  {
    "name": "Urbania hire in Bavdhan Pune",
    "description": "Urbania hire in Bavdhan Pune suitable for residential societies, family groups, corporate teams, and long-distance tours with smooth ride quality."
  },
  {
    "name": "Urbania rental in Kothrud Pune",
    "description": "Urbania rental in Kothrud Pune for local travel, airport transfers, family outings, corporate meetings, and comfortable outstation journeys."
  },
  {
    "name": "Urbania on rent near Pune Airport",
    "description": "Urbania on rent near Pune Airport offering timely airport transfers, spacious luggage handling, luxury interiors, and reliable service for domestic and international travelers."
  },
  {
    "name": "Force Urbania hire Viman Nagar Airport",
    "description": "Force Urbania hire in Viman Nagar near Pune Airport for corporate travel, airport transfers, conferences, and group transportation with punctual pickup and drop."
  },
  {
    "name": "Urbania corporate hire in Hinjewadi",
    "description": "Urbania corporate hire in Hinjewadi designed for IT companies, corporate offices, meetings, offsite programs, and employee transportation with professional standards."
  },
  {
    "name": "Urbania van hire for IT companies Pune",
    "description": "Urbania van hire for IT companies in Pune providing reliable, safe, and comfortable group transport for employees, clients, meetings, and corporate events."
  },
  {
    "name": "Urbania hire for corporate events Pune",
    "description": "Urbania hire for corporate events in Pune suitable for seminars, conferences, exhibitions, product launches, and executive movement with premium comfort."
  },
  {
    "name": "17 Seater Urbania on rent in Baner Pune",
    "description": "17 seater Urbania on rent in Baner Pune offering spacious seating, air conditioning, and smooth travel for corporate teams, families, and group tours."
  },
  {
    "name": "13 Seater Urbania hire in Kharadi Pune",
    "description": "13 seater Urbania hire in Kharadi Pune ideal for small corporate teams, airport transfers, meetings, and comfortable city travel."
  },
  {
    "name": "Force Urbania 17 seater Pimpri Chinchwad",
    "description": "Force Urbania 17 seater in Pimpri Chinchwad suitable for industrial areas, corporate travel, family outings, and long-distance group transportation."
  },
  {
    "name": "Luxury Urbania hire in Hinjewadi Pune",
    "description": "Luxury Urbania hire in Hinjewadi Pune offering premium interiors, executive seating, smooth rides, and professional chauffeurs for high-end corporate travel."
  },
  {
    "name": "Urbania corporate van hire in Viman Nagar",
    "description": "Urbania corporate van hire in Viman Nagar ideal for airport-linked corporate travel, meetings, employee transport, and executive movement."
  },
  {
    "name": "Urbania corporate hire near me Pune",
    "description": "Urbania corporate hire near you in Pune providing flexible booking, luxury vehicles, and reliable service for business travel and corporate transportation needs."
  },
  {
    "name": "Urbania hire for corporate events in Hinjewadi",
    "description": "Urbania hire for corporate events in Hinjewadi suitable for IT companies, conferences, seminars, and professional group travel."
  },
  {
    "name": "Urbania corporate van hire Viman Nagar",
    "description": "Urbania corporate van hire in Viman Nagar offering premium transport solutions for executives, airport travel, and corporate meetings."
  },
  {
    "name": "Urbania hire for IT companies Pune",
    "description": "Urbania hire for IT companies in Pune providing safe, reliable, and comfortable transport for employees, clients, and corporate events."
  },
  {
    "name": "Urbania corporate rental Pimpri Chinchwad",
    "description": "Urbania corporate rental in Pimpri Chinchwad suitable for factories, offices, corporate meetings, and employee transportation."
  },
  {
    "name": "Urbania hire Pune for corporate meetings",
    "description": "Urbania hire in Pune for corporate meetings offering punctual service, executive comfort, and professional travel experience."
  },
  {
    "name": "Urbania hire Pune for conferences",
    "description": "Urbania hire in Pune for conferences and large business gatherings with luxury interiors and coordinated group transport."
  },
  {
    "name": "Urbania for corporate seminars Pune",
    "description": "Urbania for corporate seminars in Pune providing premium group transportation for executives, speakers, and attendees."
  },
  {
    "name": "Urbania for company events Pune",
    "description": "Urbania for company events in Pune suitable for annual functions, celebrations, exhibitions, and team outings."
  },
  {
    "name": "Urbania for employee transportation Pune",
    "description": "Urbania for employee transportation in Pune offering safe, comfortable, and reliable group transport for daily and event-based corporate needs."
  }
],
"tableData": [
  ["Urbania on rent in Shivaji Nagar Pune", "Force Urbania hire in Camp Pune"],
  ["Urbania rental near Swargate Pune", "Urbania van hire near Pune Railway Station"],
  ["Urbania on rent in Deccan Pune", "Urbania on rent in Baner Pune"],
  ["Force Urbania hire in Wakad Pune", "Urbania rental in Hinjewadi Pune"],
  ["Urbania on rent in Aundh Pune", "Urbania hire in Bavdhan Pune"],
  ["Urbania rental in Kothrud Pune", "Urbania on rent near Pune Airport"],
  ["Force Urbania hire Viman Nagar Airport", "Urbania corporate hire in Hinjewadi"],
  ["Urbania van hire for IT companies Pune", "Urbania hire for corporate events Pune"],
  ["17 Seater Urbania on rent in Baner Pune", "13 Seater Urbania hire in Kharadi Pune"],
  ["Force Urbania 17 seater Pimpri Chinchwad", "Luxury Urbania hire in Hinjewadi Pune"],
  ["Urbania corporate van hire in Viman Nagar", "Urbania corporate hire near me Pune"],
  ["Urbania hire for corporate events in Hinjewadi", "Urbania corporate van hire Viman Nagar"],
  ["Urbania hire for IT companies Pune", "Urbania corporate rental Pimpri Chinchwad"],
  ["Urbania hire Pune for corporate meetings", "Urbania hire Pune for conferences"],
  ["Urbania for corporate seminars Pune", "Urbania for company events Pune"],
  ["Urbania for employee transportation Pune", "Urbania for employee transportation Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Urbania for Corporate Travel",
    "WhyChoosedescription": "Amruta Travels offers Urbania Hire for Corporate Events in Pune, providing a stylish, comfortable, and professional travel solution for business groups and company outings."
  },
  {
    "WhyChooseheading": "Ideal for Meetings, Seminars, and Team Outings",
    "WhyChoosedescription": "Whether it’s a corporate meeting, seminar, client visit, or team outing, our Urbania vehicles ensure your employees or clients travel in comfort and style."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "The Urbania features plush seating, ample legroom, air conditioning, large windows, and enough luggage space, ensuring a relaxing journey for corporate travelers."
  },
  {
    "WhyChooseheading": "Professional Drivers for Stress-Free Travel",
    "WhyChoosedescription": "Our experienced and courteous drivers are trained to handle corporate travel, ensuring punctuality, safety, and a smooth ride throughout Pune and nearby regions."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Amruta Travels offers luxury Urbania hire at affordable rates with clear, upfront pricing. No hidden charges—just excellent value for corporate travel needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All our Urbania vehicles are regularly serviced and sanitized, guaranteeing maximum comfort, safety, and cleanliness for every corporate trip."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We provide flexible scheduling, customized routes, and multiple pickup/drop-off points to suit your corporate itinerary and meeting schedules."
  },
  {
    "WhyChooseheading": "Effortless Booking and Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania for corporate events in Pune is simple with Amruta Travels. Our dedicated support team assists you at every step, ensuring a seamless experience for your company."
  }
]

    }

const faqData = [
  {
    question: 'How can I hire an Urbania for corporate events in Pune?',
    answer: 'Hiring an Urbania for corporate events in Pune is easy with Amruta Travels. You can book online, call our support team, or visit our office, and we will help you select the ideal vehicle for your group.'
  },
  {
    question: 'What makes the Urbania suitable for corporate travel?',
    answer: 'The Urbania provides comfortable seating, air conditioning, spacious interiors, large windows, and modern amenities—perfect for business groups, team outings, and client transport.'
  },
  {
    question: 'Can Urbania be used for corporate outstation trips?',
    answer: 'Yes, Urbania is ideal for both local and outstation corporate trips. It ensures a smooth, safe, and comfortable journey even for long distances.'
  },
  {
    question: 'Do I get a driver with the Urbania hire?',
    answer: 'Yes, every Urbania hire comes with a professional and courteous driver, ensuring punctuality, safety, and a stress-free travel experience for corporate events.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, sanitized, and maintained to provide maximum safety, comfort, and hygiene for corporate passengers.'
  },
  {
    question: 'What is the cost of Urbania hire for corporate events in Pune?',
    answer: 'The cost depends on the duration, distance, and specific requirements of your corporate trip. Contact Amruta Travels for a customized and transparent quote.'
  },
  {
    question: 'Can I customize pickup and drop-off points for my corporate event?',
    answer: 'Yes, we provide flexible pickup and drop-off options along with customized routes tailored to your corporate itinerary and schedules.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania hire for corporate events?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and dedicated support, ensuring a premium, stress-free experience for your corporate travel.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Akash Mehta',
    role: 'HR Manager, Pune',
    text: 'We hired an Urbania for our company team outing. The vehicle was spacious, clean, and very comfortable. The driver was professional and punctual. Amruta Travels provided excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Riya Sharma',
    role: 'Event Coordinator, Pune',
    text: 'Booked an Urbania for transporting employees to a corporate seminar. The vehicle was luxurious and comfortable. The driver was courteous and reliable. Highly recommend Amruta Travels!',
    rating: 5
  }
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Corporate Events Pune",
  "image": "https://bushireinpune.com/assets/images/urbania-hire-for-corporate-events-pune.jpg",
  "description": "Hire Force Urbania for corporate events in Pune with Amruta Travels. Ideal for IT companies, corporate meetings, conferences, seminars, employee transportation, and company events. Available across Shivaji Nagar, Camp, Swargate, Deccan, Baner, Wakad, Hinjewadi, Aundh, Bavdhan, Kothrud, Pimpri Chinchwad, Viman Nagar, Pune Railway Station, and Pune Airport. Luxury 13 and 17 seater Urbania vans for corporate travel and airport transfers at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-hire-for-corporate-events-pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania Hire for Corporate Events in Pune | Amruta Travels</title>
  <meta
    name="description"
    content="Urbania hire for corporate events in Pune with Amruta Travels. Luxury Force Urbania vans for IT companies, meetings, conferences, seminars, airport transfers & employee transportation in Hinjewadi, Viman Nagar & across Pune."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/99.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniahireforcorporateeventspune;